import api from '../api/axios';

export interface PurchaseOrderItem {
  id?: number;
  purchaseOrder?: number;
  product?: number;
  description?: string;
  quantity: number;
  unitPrice: number;
  discount?: number;
  tax?: number;
  total: number;
  receivedQuantity?: number;
}

export interface PurchaseOrder {
  id?: number;
  orderNumber: string;
  supplier?: number | null;
  requisition?: number;
  orderDate: string;
  expectedDelivery?: string;
  actualDelivery?: string;
  subtotal: number;
  tax: number;
  discount: number;
  total: number;
  status?: 'draft' | 'sent' | 'confirmed' | 'partiallyReceived' | 'received' | 'cancelled';
  notes?: string;
  createdBy?: number;
}

const PurchaseOrderService = {
  getAll: (params?: any) => api.get('/purchase-orders', { params }),
  getOne: (id: number, params?: any) => 
    api.get(`/purchase-orders/${id}`, { 
      params: params || { populate: ['supplier', 'requisition', 'createdBy'] } 
    }),
  create: (data: PurchaseOrder) => api.post('/purchase-orders', { data }),
  update: (id: number, data: Partial<PurchaseOrder>) => 
    api.put(`/purchase-orders/${id}`, { data }),
  delete: (id: number) => api.delete(`/purchase-orders/${id}`),
  
  // Purchase Order Items
  getItems: (purchaseOrderId: number) =>
    api.get('/purchase-order-items', {
      params: {
        'filters[purchaseOrder][id][$eq]': purchaseOrderId,
        populate: 'product',
      },
    }),
  createItem: (data: PurchaseOrderItem) => api.post('/purchase-order-items', { data }),
  updateItem: (id: number, data: Partial<PurchaseOrderItem>) =>
    api.put(`/purchase-order-items/${id}`, { data }),
  deleteItem: (id: number) => api.delete(`/purchase-order-items/${id}`),
};

export default PurchaseOrderService;

